<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights"/>
      <list-panel @updateIdx="updateIdx" :selIdx="selIdx" :config="config" :isAutoLoad='1' :rs="rs" />
  <detail v-if="showDetail" @close="closeDetail" :rs="rs" :width="'700px'" :url="config.url" 
   :config="config"  />
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";
import detail from "./detail";

export default {
  data() {
    return {
      config: data,
      showDetail: false
    };
  },
  methods: {
    add(){
      this.showDetail = true 
    },
    closeDetail(){
      this.showDetail = false
      this.$loadData(this.config)
    }
  },
  components: {
    detail
  },
  mixins:[mixin.list]
};
</script>
